// extracted by mini-css-extract-plugin
export default {"link":"NoAccess_link__6+2qm"};